import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckedCircleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99961 2.79985C10.8721 2.79985 13.1996 5.12735 13.1996 7.99985C13.1996 10.8724 10.8721 13.1999 7.99961 13.1999C5.12711 13.1999 2.79961 10.8724 2.79961 7.99985C2.79961 5.12735 5.12711 2.79985 7.99961 2.79985ZM7.99961 14.3999C11.5346 14.3999 14.3996 11.5349 14.3996 7.99985C14.3996 4.46485 11.5346 1.59985 7.99961 1.59985C4.46461 1.59985 1.59961 4.46485 1.59961 7.99985C1.59961 11.5349 4.46461 14.3999 7.99961 14.3999ZM10.1096 6.91735C10.2846 6.63735 10.1996 6.26735 9.91961 6.08985C9.63961 5.91235 9.26961 5.99985 9.09211 6.27985L7.55711 8.73735L6.88211 7.83735C6.68211 7.57235 6.30711 7.51735 6.04211 7.71735C5.77711 7.91735 5.72211 8.29235 5.92211 8.55735L7.12211 10.1574C7.23961 10.3149 7.42961 10.4049 7.62711 10.3974C7.82461 10.3899 8.00461 10.2849 8.10961 10.1149L10.1096 6.91485V6.91735Z",
		fill: "#4D4540"
	})
});
export default SvgCheckedCircleRegularIcon;
